<template>
  <div>
    <div v-show="loading">
      <Loading />
    </div>
    <div v-if="errored">
      <ErrorPage />
    </div>
    <div v-else-if="stateDadosEstabelecimento != null" class="home">
      <Banner></Banner>

      <div v-if="notfound">
        <NotFound titulo="Cardápio" />
      </div>

      <div class="content-size section-home-noradius scrolling-wrapper" id="categoriesHeader">
        <div class="card" v-for="(categoria, i) in filterProducts" :key="i">
          <a
            :href="'#' + removeEspacoCaracterEspecial(categoria.categoriaNome.toLowerCase())"
            v-smooth-scroll="{ duration: 1000, offset: -120 }"
          >
            {{
            categoria.categoriaNome
            }}
          </a>
        </div>
      </div>

      <div class="content">
        <div class="content-size section-home s-category home-news">
          <div class="form-group" v-if="paises">
            <select v-model="searchProduct" class="form-control">
              <option
                v-for="pais in paises"
                :key="pais.nome"
                :value="pais.nome"
                :selected="pais.id === 0"
              >{{ pais.nome }}</option>
            </select>
          </div>

          <div class="news-list-page-section content" v-for="(itens, i) in filterProducts" :key="i">
            <div
              class="wrap-news-list"
              v-if="itens.produtos.length > 0"
              :id="removeEspacoCaracterEspecial(itens.categoriaNome.toLowerCase())"
            >
              <div class="heading-page">{{ itens.categoriaNome }}</div>
              <div class="section-news-list" v-for="(produto, ii) in itens.produtos" :key="ii">
                <div class="home-news-wrap">
                  <div class="news-item">
                    <div
                      class="news-content"
                      @click="linkDetalheProduto(produto.id, produto)"
                      style="cursor: pointer"
                    >
                      <div :class="(exibeImagem(produto.imagem)) ? `hnw-desc` : `hnw-desc-100`">
                        <div class="hnw-title">{{ produto.nome }}</div>
                        <div class="hnw-text">
                          <div v-if="produto.pais.nome != null">
                            <img
                              class="img-flag"
                              :src="'/img/flags/' + produto.pais.icone"
                              :alt="produto.pais.nome"
                            />
                            <span class="text-country">{{ produto.pais.nome }}</span>
                          </div>
                          {{ produto.descricao }}
                          <p
                            class="more"
                          >{{ produto.legendaPrecoAPartir && !produto.pais.nome ? produto.legendaPrecoAPartir : "" }} R$ {{ formatarPreco(produto.preco) }}</p>
                          <div class="wrap-list-rc">
                            <div class="lrc-button">
                              <div class="lrcb-left">
                                <!-- <span class="lhc like">
                                  <font-awesome-icon :icon="['far', 'thumbs-up']" size="2x" />0
                                </span>-->
                                <!-- <span class="lhc like">
                                  <font-awesome-icon :icon="['far', 'thumbs-down']" size="2x" />0
                                </span>
                                <span class="lhc comment">
                                  <font-awesome-icon :icon="['far', 'comment-dots']" size="2x" />0
                                </span>-->
                              </div>
                              <div class="lrcb-right"></div>
                              <div class="clear"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        :class="(exibeImagem(produto.imagem)) ? `hnw-img` : ``"
                        v-if="exibeImagem(produto.imagem)"
                      >
                        <Imagem :key="produto.imagem" :caminhoImagem="produto.imagem"></Imagem>
                      </div>
                      <div class="hnw-below"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/views/cardapios/components/Banner";
import Imagem from "@/components/Imagem";
import ErrorPage from "@/components/template/ErrorPage";
import NotFound from "@/components/template/NotFound";
import Loading from "@/components/template/Loading";

import FunctionsMixin from '@/utils/functionsMixin.js'
import moduleCardapio from '@/store/cardapios/moduleCardapio.js';

export default {
  name: "Cardapios-Produtos",

  components: {
    Banner,
    Imagem,
    ErrorPage,
    NotFound,
    Loading
  },

  mixins: [FunctionsMixin],

  props: {
    EstabelecimentoId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      searchProduct: "Filtrar por País",
      loading: false,
      errored: false,
      notfound: false
    };
  },

  watch: {
    EstabelecimentoId: function (newVal) {
      this.initLoad(newVal);
    }
  },

  computed: {
    stateDadosEstabelecimento() {
      return this.$store.state.dadosEstabelecimento
    },
    cardapio() {
      return this.$store.getters['moduleCardapio/sortNameTypeMenu'](this.$route.query.m)
    },
    paises() {
      if (this.cardapio) {
        const paises = !moduleCardapio.isRegistered ? null : this.$store.state.moduleCardapio.paises
        return paises && this.cardapio.configuracoes.filtrarPais ? paises : null
      } else
        return null
    },
    filterProducts() {
      let search = this.searchProduct.toLowerCase().trim();

      if (search === "todos" || search === "filtrar por país") search = "";

      const categorias = this.cardapio ? this.cardapio.categorias : []
      if (!search) return categorias

      const filteredProducts = [];
      for (let i = 0; i < categorias.length; i++) {
        const elementCategory = categorias[i];

        const productsArray = [];
        for (let ii = 0; ii < elementCategory.produtos.length; ii++) {
          const elementProduct = elementCategory.produtos[ii];

          if (elementProduct.pais.nome.toLowerCase().trim() === search)
            productsArray.push(elementProduct);
        }

        if (productsArray.length > 0)
          filteredProducts.push({
            categoriaNome: elementCategory.categoriaNome,
            produtos: productsArray
          });
      }
      return filteredProducts;
    }
  },

  created() {
    if (this.stateDadosEstabelecimento)
      this.initLoad(this.stateDadosEstabelecimento.estabelecimentoId);
  },

  mounted() {
    if (this.stateDadosEstabelecimento && this.$route.query.m) this.scrollHeaderFixed();
  },

  updated() {
    if (this.stateDadosEstabelecimento && this.$route.query.m) this.scrollHeaderFixed();
  },

  methods: {
    initLoad(estabelecimentoId) {
      if (this.$route.query.m) {
        if (!moduleCardapio.isRegistered) {
          this.$store.registerModule('moduleCardapio', moduleCardapio)
          moduleCardapio.isRegistered = true
        }

        if (!this.cardapio) {
          const data = {
            estabelecimentoId: estabelecimentoId,
            tipoCardapio: this.$route.query.m
          }
          this.$store.dispatch('moduleCardapio/fetchCardapio', data)
        }
        this.notfound = false;
      } else {
        this.notfound = true;
      }
    },
    linkDetalheProduto(produtoId, produto) {
      this.$router.push({
        name: "Cardapios-ProdutoDetalhe",
        params: {
          produtoId,
          produtoArray: produto
        }
      });
    },
    scrollHeaderFixed() {
      let self = this;
      let sticky = document.getElementById("categoriesHeader");
      let stickyTop = sticky.getBoundingClientRect().top;
      let scrolled = false;

      window.addEventListener("scroll", function () {
        scrolled = true;
      });

      setInterval(function () {
        if (scrolled) {
          scrolled = false;
          if (window.pageYOffset > stickyTop + 23) {
            self.isScrolled = true;
            sticky.classList.add("sticky");
          } else {
            self.isScrolled = false;
            sticky.classList.remove("sticky");
          }
        }
      }, 100);
    }
  }
};
</script>

<style scoped>
.sticky {
  position: fixed;
  top: 56px;
  left: 6px;
  z-index: 20;
  border-top: 10px solid #fff;
  border-bottom: 10px solid #fff;
}

.sticky + .content {
  padding-top: 55px;
}

@media (min-width: 1024px) {
  .sticky {
    left: 50%;
    transform: translateX(-400px);
  }
}
</style>
